import React from "react"
import { useNavigate } from "react-router-dom"
import { reportShowPath } from "@/QuarterlyReportApp"
import { ArrowLeft } from "lucide-react"
import { ReportSection } from "~/api/communications"
import { Button } from "@/ui/Button"
import QuarterlyReportLayout from "./QuarterlyReportLayout"
import { useCommunicationContext } from "./CommunicationContext"
import { useQuarterlyReportContext } from "./useQuarterlyReportContext"

const QpcspFinancialStatement: React.FC = () => {
  const { communicationId, communication } = useCommunicationContext()
  const { reportId, report, isLoading, error } = useQuarterlyReportContext()
  const navigate = useNavigate()

  const financialStatementDoc = communication?.documents?.find(
    (doc) => doc.document_type === "financial_statement",
  )

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Loading QPCSP Financial Statement...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Failed to load report: {error.message}
      </div>
    )
  }

  if (!report) {
    return (
      <div className="alert alert-warning" role="alert">
        Report not found
      </div>
    )
  }

  return (
    <QuarterlyReportLayout
      title="QPCSP Financial Statement"
      subtitle={`${report.household_name}`}
      actions={
        <Button
          size="md"
          variant="outline"
          icon={<ArrowLeft size={18} />}
          onClick={() =>
            navigate(reportShowPath({ communicationId, reportId }))
          }
        >
          Back to Report
        </Button>
      }
      breadcrumbProps={{
        householdName: report.household_name,
        householdPath: reportShowPath({ communicationId, reportId }),
        sectionName: ReportSection.QPCSP_FINANCIAL_STATEMENT,
      }}
    >
      {financialStatementDoc?.file_url ? (
        <div className="pdf-viewer-container">
          <iframe
            src={financialStatementDoc.file_url}
            title="QPCSP Financial Statement"
          />
        </div>
      ) : (
        <div className="alert alert-info" role="alert">
          No financial statement has been uploaded for this report. Upload one
          in the report configuration step.
        </div>
      )}
    </QuarterlyReportLayout>
  )
}

export default QpcspFinancialStatement
